export default __webpack_public_path__ + "static/citilink-03a96ebde817e70bb0b4c281bf7f1e51.png";